import { RouteObject, useSearchParams } from "react-router-dom";
import { TopBarPageContainer } from "@components/PageContainer";
import { ValidatedRoutes } from "@components/PermissionedRoutes";

export const BANKING_ACH_MANAGER_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { AchManagerTable } = await import("@pages/banking_ach_manager/AchManagerTable");
      return {
        Component() {
          const [searchParams] = useSearchParams();
          return (
            <TopBarPageContainer title={["Transactions", "ACH Manager", "Transfers"]}>
              <AchManagerTable selectedId={searchParams.get("selectedId") ?? null} />
            </TopBarPageContainer>
          );
        },
      };
    },
  },
  {
    path: "ai_search",
    element: (
      <ValidatedRoutes
        validate={(userConfiguration) => {
          const { isFeatureEnabled, permissions } = userConfiguration;
          return (
            isFeatureEnabled("command_ai_search", "db_ach_manager") &&
            permissions.includes("backoffice.use_ai_search")
          );
        }}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { AiSearch } = await import("@pages/banking_ach_manager/ai_search/AiSearch");
          return { element: <AiSearch /> };
        },
      },
      {
        path: ":threadId",
        async lazy() {
          const { DbAchManagerAiThread } = await import(
            "@pages/banking_ach_manager/ai_search/AiThread"
          );
          return { element: <DbAchManagerAiThread /> };
        },
      },
    ],
  },
];
